import { render, staticRenderFns } from "./ScenarioChanges.vue?vue&type=template&id=21e4a7d0&scoped=true&"
import script from "./ScenarioChanges.vue?vue&type=script&lang=js&"
export * from "./ScenarioChanges.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioChanges.vue?vue&type=style&index=0&id=21e4a7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4a7d0",
  null
  
)

export default component.exports